// import {
//   FaGithub,
//   FaExternalLinkAlt,
//   FaTelegram,
//   FaVideo,
// } from 'react-icons/fa';

// const ProjectCard = ({ project }) => {
//   return (
//     <div className='bg-[#111111] p-6 rounded-lg shadow-lg max-w-[500px] mx-auto'>
//       {/* Thumbnail */}
//       <img
//         src={project.thumbnail}
//         alt={project.title}
//         className='w-full h-40 object-cover rounded-md mb-4'
//       />

//       {/* Title */}
//       <h3 className='text-2xl font-semibold mb-2 text-white'>
//         {project.title}
//       </h3>

//       {/* Description */}
//       <p className='text-gray-300 mb-4'>{project.description}</p>

//       {/* Tags */}
//       <div className='flex flex-wrap gap-2 mb-4'>
//         {project.tags.map((tag, idx) => (
//           <span
//             key={idx}
//             className='bg-gray-700 text-sm px-3 py-1 rounded-full text-gray-200'
//           >
//             {tag}
//           </span>
//         ))}
//       </div>

//       {/* Links */}
//       <div className='flex flex-wrap gap-4 mt-4'>
//         {project.githubLink && (
//           <a
//             href={project.githubLink}
//             target='_blank'
//             rel='noopener noreferrer'
//             className='text-blue-400 flex items-center space-x-2'
//           >
//             <FaGithub /> <span>GitHub</span>
//           </a>
//         )}
//         {project.liveUrl && (
//           <a
//             href={project.liveUrl}
//             target='_blank'
//             rel='noopener noreferrer'
//             className='text-green-400 flex items-center space-x-2'
//           >
//             <FaExternalLinkAlt /> <span>Live Site</span>
//           </a>
//         )}
//         {project.telegramLink && (
//           <a
//             href={project.telegramLink}
//             target='_blank'
//             rel='noopener noreferrer'
//             className='text-blue-400 flex items-center space-x-2'
//           >
//             <FaTelegram /> <span>Telegram</span>
//           </a>
//         )}
//         {project.demoVideo && (
//           <a
//             href={project.demoVideo}
//             target='_blank'
//             rel='noopener noreferrer'
//             className='text-red-400 flex items-center space-x-2'
//           >
//             <FaVideo /> <span>Demo Video</span>
//           </a>
//         )}
//       </div>
//     </div>
//   );
// };

// export default ProjectCard;


import {
  FaGithub,
  FaExternalLinkAlt,
  FaTelegram,
  FaVideo,
} from 'react-icons/fa';
import { motion } from 'framer-motion';

const ProjectCard = ({ project }) => {
  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: 'easeOut' },
    },
  };

  const hoverEffect = {
    rest: { scale: 1 },
    hover: { scale: 1.05, transition: { duration: 0.3 } },
  };

  return (
    <motion.div
      className='bg-[#111111] p-6 rounded-lg shadow-lg max-w-[500px] mx-auto'
      variants={cardVariants}
      initial='hidden'
      whileInView='visible'
      viewport={{ once: true, amount: 0.2 }}
    >
      {/* Thumbnail */}
      <motion.img
        src={project.thumbnail}
        alt={project.title}
        className='w-full h-40 object-cover rounded-md mb-4'
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.3, duration: 0.6, ease: 'easeOut' }}
        whileHover={{ scale: 1.05 }}
      />

      {/* Title */}
      <motion.h3
        className='text-2xl font-semibold mb-2 text-white'
        initial={{ x: -20, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ delay: 0.4, duration: 0.5 }}
      >
        {project.title}
      </motion.h3>

      {/* Description */}
      <motion.p
        className='text-gray-300 mb-4'
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5, duration: 0.5 }}
      >
        {project.description}
      </motion.p>

      {/* Tags */}
      <motion.div
        className='flex flex-wrap gap-2 mb-4'
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.6, duration: 0.5 }}
      >
        {project.tags.map((tag, idx) => (
          <motion.span
            key={idx}
            className='bg-gray-700 text-sm px-3 py-1 rounded-full text-gray-200'
            variants={hoverEffect}
            initial='rest'
            whileHover='hover'
          >
            {tag}
          </motion.span>
        ))}
      </motion.div>

      {/* Links */}
      <motion.div
        className='flex flex-wrap gap-4 mt-4'
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.7, duration: 0.5 }}
      >
        {project.githubLink && (
          <motion.a
            href={project.githubLink}
            target='_blank'
            rel='noopener noreferrer'
            className='text-blue-400 flex items-center space-x-2'
            whileHover={{ scale: 1.1, color: '#1DA1F2' }}
          >
            <FaGithub /> <span>GitHub</span>
          </motion.a>
        )}
        {project.liveUrl && (
          <motion.a
            href={project.liveUrl}
            target='_blank'
            rel='noopener noreferrer'
            className='text-green-400 flex items-center space-x-2'
            whileHover={{ scale: 1.1, color: '#34D399' }}
          >
            <FaExternalLinkAlt /> <span>Live Site</span>
          </motion.a>
        )}
        {project.telegramLink && (
          <motion.a
            href={project.telegramLink}
            target='_blank'
            rel='noopener noreferrer'
            className='text-blue-400 flex items-center space-x-2'
            whileHover={{ scale: 1.1, color: '#1DA1F2' }}
          >
            <FaTelegram /> <span>Telegram</span>
          </motion.a>
        )}
        {project.demoVideo && (
          <motion.a
            href={project.demoVideo}
            target='_blank'
            rel='noopener noreferrer'
            className='text-red-400 flex items-center space-x-2'
            whileHover={{ scale: 1.1, color: '#F87171' }}
          >
            <FaVideo /> <span>Demo Video</span>
          </motion.a>
        )}
      </motion.div>
    </motion.div>
  );
};

export default ProjectCard;
